import { cn } from '@mint-lib/tw-utils';

import { useCharacterLimit } from '../../hooks/useCharacterLimit.js';
import { InputHelperText, InputLabel, InputRoot } from '../../lib/input.jsx';
import { Textarea, type TextareaProps } from '../../lib/text-area.jsx';

function TextArea({
  className,
  helperText,
  label,
  infoIconWithTooltip,
  onChange,
  maxLength,
  ...props
}: TextareaProps & {
  helperText?: string;
  maxLength?: number;
  label?: string;
  infoIconWithTooltip?: string;
}) {
  const {
    value,
    characterCount,
    maxLength: limit,
    handleChange,
  } = useCharacterLimit({
    maxLength,
    value: (props.value as string) ?? '',
    onChange,
  });

  return (
    <InputRoot className={cn('h-auto w-full', className)}>
      {label && (
        <InputLabel
          htmlFor={props.id || ''}
          label={label}
          infoIconWithTooltip={infoIconWithTooltip}
        />
      )}
      <Textarea
        maxLength={limit}
        value={value}
        onChange={handleChange}
        className={className}
        {...props}
      />
      <div
        className={cn('flex', helperText ? 'justify-between' : 'justify-end')}
      >
        {helperText && (
          <InputHelperText helperText={helperText} color={props.color} />
        )}
        {Boolean(limit) && (
          <InputHelperText
            helperText={`${characterCount}/${limit}`}
            color={'default'}
          />
        )}
      </div>
    </InputRoot>
  );
}
export default TextArea;
